import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import heroBg from '../assets/img/ic_our_service_background.png';

export default function Flights() {
  return (
    <div className="bg-navy-950">
      <PageHero
        title="Flights"
        subtitle="Flight options and booking guidance for business and leisure travel."
        backgroundImage={heroBg}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-justify leading-relaxed text-white/80">
          Our team helps you compare routes and schedules, understand requirements, and move forward with
          confidence on your air travel plans.
        </p>
      </section>
    </div>
  );
}
